import { Tooltip } from "@mui/material";
import React from "react";
import { truncate } from "utils/string";

const ReportTitle = ({ data, openDrawer }) => {
  return data?.reportTitle?.length > (openDrawer ? 70 : 100) ? (
    <Tooltip title={<h3>{data?.reportTitle ?? "Report"}</h3>} placement="top">
      <div className="view-pdf__header--title">
        {data?.name
          ? truncate(data?.reportTitle, openDrawer ? 70 : 100)
          : "Report"}
      </div>
    </Tooltip>
  ) : (
    <div className="view-pdf__header--title" style={{ cursor: "default" }}>
      {data?.reportTitle ?? "Report"}
    </div>
  );
};

export default ReportTitle;
